import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getCustomerOrders,
  getStore,
  getStoreCustomerAccount,
  getStoreCustomerBalance,
  getStoreCustomerOrderRevenue,
  postStoreCustomerAccount,
  storeCustomerGetInfo,
  StoreCustomerOrderRevenue,
  StoreCustomerPendingOrderRevenue,
} from "../../services/CustomerInfo/CustomerInfo";
import { getNextPickupTime, getStoreLocalData, getUserData, setNextPickupTime } from "../../utils/localStorage";
import { getCartDetail, getCartDetailV2 } from "../../services/Cart/cartDetail";
import { formatDate, formatDateNew, localeDateEndDate, localeDateStartDate } from "../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { Alert } from "react-bootstrap";
import PickupRequest from "../PickupAndDeliveryModal/PickupRequest";
import DeliveryRequest from "../PickupAndDeliveryModal/DeliveryRequest";
import SuccessModal from "../SuccessModal";

import { ProgressSpinner } from "primereact/progressspinner";
import StoreMenu from "../StoreMenu";
// import OrderNotification from "../OrderComponents/OrderNotification";
import { getCustomerOldOrderLedger } from "../../services/CustomerInfo/OldOrder";
import ButtonLink from "../../ButtonLink";
import { Toast } from "primereact/toast";
import { getStoreNewPick } from "../../services/DashboardAPI/DashboardApi";
import PickupNotification from "../../assets/sounds/pickup-notification.mp3"

const { innerWidth: width, innerHeight: height } = window;

const CardData = [
  {
    id: 1,
    name: "Book New Order",
    fillColor: "#DDFFDF",
    borderColor: "#55BD5A",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif",
    height: height < 600 ? 50 : 60,
    width: height < 600 ? 70 : 80,
  },
  {
    id: 2,
    name: "Pickup Request",
    fillColor: "#E0F1FF",
    borderColor: "#3EB3E1",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Pickup_Request.gif",
    height: height < 600 ? 50 : 60,
    width: height < 600 ? 50 : 60,
  },
  {
    id: 3,
    name: "Delivery Request",
    fillColor: "#F3EFFF",
    borderColor: "#866CCE",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Deliver_Request.gif",
    height: height < 600 ? 50 : 60,
    width: height < 600 ? 50 : 60,
  },
  {
    id: 4,
    name: "Customer Account",
    fillColor: "#E9F2FF",
    borderColor: "#6EA4F5",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Customer_Account.gif",
    height: height < 600 ? 40 : 50,
    width: height < 600 ? 50 : 60,
  },
  {
    id: 5,
    name: "Running Order",
    fillColor: "#FFF7D1",
    borderColor: "#F5C33A",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Running_Order.gif",
    height: height < 600 ? 60 : 70,
    width: height < 600 ? 60 : 70,
  },
  {
    id: 6,
    name: "Close Order",
    fillColor: "#FFEFDD",
    borderColor: "#E89534",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Closed_Order.gif",
    height: height < 600 ? 50 : 60,
    width: height < 600 ? 50 : 60,
  },
  {
    id: 7,
    name: "Cancel Order",
    fillColor: "#FFE2E2",
    borderColor: "#FF6767",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Cancel_Order.gif",
    height: height < 600 ? 50 : 60,
    width: height < 600 ? 50 : 60,
  },
  {
    id: 8,
    name: "Get All Order",
    fillColor: "#E8E8E8",
    borderColor: "#75879B",
    gif: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Get_All_Order.gif",
    height: height < 600 ? 60 : 70,
    width: height < 600 ? 60 : 70,
  },
];

const CustomerInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId } = location.state || {}; // Fallback to prevent undefined errors

  const { storeData, userProfileData, userProfileRole, brandProfileData } =
    getUserData();

  const storeId = storeData.id;
  const brandId = brandProfileData.id;
  const userProfileId = userProfileData.id;
  const enabledCustomerRevenueDetailV2 = storeData.enabledCustomerRevenueDetailV2;
  const enabledOldOrderFeature = storeData.enabledOldOrderFeature;
  const enabledLoyaltyPointStore = storeData.enabledLoyaltyPoint;
  const enabledLoyaltyPointBrand = brandProfileData.enabledLoyaltyPoint;
  const enabledNewPickupStoreNotified = storeData.enabledNewPickupStoreNotified;
  const B2BModelBrand = brandProfileData.enabledB2BModel;
  const B2BModelStore = storeData.enabledB2BModel;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;  

  const { storeLocalData } = getStoreLocalData();

  const userRole = userProfileRole;

  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState({});
  const [customerOrdersData, setCustomerOrdersData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [customerALLOrdersData, setCustomerALLOrdersData] = useState([]);
  const [customerAccountEnable, setCustomerAccountEnable] = useState(false);
  const [cartData, setCartData] = useState([]);
  const [customerOldOrderLedgerData, setCustomerOldOrderLedgerData] = useState(
    {}
  );

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(null);
  const [apiResMessage, setApiResMessage] = useState("");
  // const [orderNotificationVisible, setOrderNotificationVisible] =
  //   useState(false);
  // const [orderNotificationMessageType, setOrderNotificationMessageType] =
  //   useState("");

  const [pickupRequestModalVisible, setPickupRequestModalVisible] = useState();
  const [deliveryRequestModalVisible, setDeliveryRequestModalVisible] =
    useState();
  const [visible, setVisible] = useState(false);
 

const [
  storeCustomerUpcomingOrderRevenueData,
  setStoreCustomerUpcomingOrderRevenueData,
] = useState([]);

  // To set the default Star Selected
  const [defaultRating, setDefaultRating] = useState(null);

  const [startDateDashboard, setStartDateDashboard] = useState(null);
  const [endDateDashboard, setEndDateDashboard] = useState(null);

   const toast = useRef(null);
    const audioRef = useRef(null);
    const hasNotifiedRef = useRef(false);
  

  const showInfo = (data) => {
      toast.current?.show({
        severity: "info",
        summary: "Notification",
        detail: `You got a ${data > 1 ? data : ""} new pick up request, please check`,
        life: 10000,
      });
  
      // 🔊 Play sound
      if (audioRef.current) {
        audioRef.current.currentTime = 0; // restart sound
        audioRef.current.play().catch(() => {
          // autoplay might be blocked until user interaction
        });
      }
    };
  
    // useEffect(() => {
    //   const unlockAudio = () => {
    //     if (audioRef.current) {
    //       audioRef.current.play().then(() => {
    //         audioRef.current.pause();
    //         audioRef.current.currentTime = 0;
    //       });
    //     }
    //     document.removeEventListener("click", unlockAudio);
    //   };
  
    //   document.addEventListener("click", unlockAudio);
  
    //   return () => document.removeEventListener("click", unlockAudio);
    // }, []);
  
    const fetchStoreNewPick = async () => {
      try {
        const response = await getStoreNewPick(storeId);
  
        if (!response.data.error) {
          if (response.data > 0 && !hasNotifiedRef.current) {
            showInfo(response.data);
            hasNotifiedRef.current = true;
          }
  
          // reset when no pickup exists
          if (response.data === 0) {
            hasNotifiedRef.current = false;
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    useEffect(() => {
        if (enabledNewPickupStoreNotified) {
    
          // Initialize timer if not present
          if (!getNextPickupTime()) {
            setNextPickupTime();
          }
    
          const interval = setInterval(() => {
            const nextTime = getNextPickupTime();
            const now = Date.now();
    
            if (now >= nextTime) {
              // ⏰ Time is zero → call API
              fetchStoreNewPick();
    
              // 🔄 Reset timer
              setNextPickupTime();
            }
          }, 1000); // check every second
    
          return () => clearInterval(interval);
        }
      }, [enabledNewPickupStoreNotified]);
  
    // useEffect(() => {
    //   const interval = setInterval(() => {
    //     fetchStoreNewPick();
    //   }, 15000); // 15 seconds
  
    //   return () => clearInterval(interval);
    // }, []);

  const fetchStoreCustomerInfo = async () => {
    try {
      const response = await storeCustomerGetInfo(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setCustomerData(Res);
        setDefaultRating(Res?.brandCustomer?.starRating);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const CreateStoreCustomerAccount = () => {
  //   const data = {
  //     status: "true",
  //     autoPay: "false",
  //     creditLimit: "0",
  //     storeCustomer: {
  //       id: storeCustomerId,
  //     },
  //   };
  //   postStoreCustomerAccount(storeCustomerId, storeId, data)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const CreateStoreCustomerAccountResponse = response.data;
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  // const [StoreCustomerAccountResponseData, setStoreCustomerAccountResponse] = useState("")

  // const fetchStoreCustomerAccount = () => {
  //   getStoreCustomerAccount(storeCustomerId, storeId)
  //     .then((response) => {
  //       if (!response.data.error) {
  //         const StoreCustomerAccountResponse = response.data;
  //         // setStoreCustomerAccountResponse(StoreCustomerAccountResponse)
  //         if (StoreCustomerAccountResponse === "") {
  //           // CreateStoreCustomerAccount();
  //         } else {
  //         }
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Error:", err);
  //     });
  // };

  const [
    storeCustomerPendingOrderOverAllRevenueData,
    setStoreCustomerPendingOrderOverAllRevenueData,
  ] = useState('');

  const [storeCustomerDeliveredOrderBalance, setStoreCustomerDeliveredOrderBalance] = useState("")

  const fetchStoreCustomerOrderRevenueAll = (data) => {
    StoreCustomerOrderRevenue(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          const overallStatuses = [
            "BOOKED",
            "INPROCESS",
            "PROCESSED",
            "IN_WAREHOUSE",
            "DELIVERED",
            "DONE",
            "OUT_FOR_DELIVERY",
          ];

          const PendingOrderOverAllRevenueData = Res.filter(
            (item) => overallStatuses.includes(item.status)
          );

          // Calculate totals
          const PendingOrderOverAllRevenueDataTotals =
            PendingOrderOverAllRevenueData.reduce(
              (acc, item) => {
                acc.count += item.count || 0;
                acc.revenue += item.revenue || 0;
                acc.balance += item.balance || 0;
                return acc;
              },
              { count: 0, revenue: 0, balance: 0 }
            );

          setStoreCustomerPendingOrderOverAllRevenueData(
            PendingOrderOverAllRevenueDataTotals
          );

          // DELIVERED

          const DeliveredOrderBalance = Res.filter(
            (item) => item.status === "DELIVERED"
          );

          // Calculate totals
          const DeliveredOrderBalanceTotals =
            DeliveredOrderBalance.reduce(
              (acc, item) => {
                acc.count += item.count || 0;
                acc.revenue += item.revenue || 0;
                acc.balance += item.balance || 0;
                return acc;
              },
              { count: 0, revenue: 0, balance: 0 }
            );


          setStoreCustomerDeliveredOrderBalance(DeliveredOrderBalanceTotals);

          //

          const upcomingStatuses = [
            "BOOKED",
            "INPROCESS",
            "IN_WAREHOUSE",
            "PROCESSED",
            "OUT_FOR_DELIVERY",
          ];

          const UpcomingOrderRevenueData = Res.filter((item) =>
            upcomingStatuses.includes(item.status)
          );

          // Calculate totals
          const UpcomingOrderRevenueDataTotals =
            UpcomingOrderRevenueData.reduce(
              (acc, item) => {
                acc.count += item.count || 0;
                acc.revenue += item.revenue || 0;
                acc.balance += item.balance || 0;
                return acc;
              },
              { count: 0, revenue: 0, balance: 0 }
            );

          setStoreCustomerUpcomingOrderRevenueData(
            UpcomingOrderRevenueDataTotals
          );
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };


  const fetchCustomerOrders = async () => {
    setLoading(true);

    const data = {
      offset: 0,
      limit: 3,
      statusIn: [
        "BOOKED",
          "INPROCESS",
          "IN_WAREHOUSE",
          "PROCESSED",
          "DELIVERED",
          "DONE",
          "CANCEL",
          "UNPROCESSED",
          "OUT_FOR_DELIVERY",
          "DELAY_STATUS",
      ]
    }
    try {
      const response = await getCustomerOrders(storeCustomerId, storeId, data);
      if (!response.data.error) {
        const Res = response.data;
        setCustomerALLOrdersData(response.data);
        setCustomerOrdersData(Res);
        setSelectedItem(Res[0]?.id);
        setLoading(false);
        // setShowActivityIndicator(false);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const fetchCartDetail = async () => {
    try {
      const response = await getCartDetailV2(storeCustomerId, storeId);
      if (!response.data.error) {
        const cartRes = response.data;
        setCartData(cartRes);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // const fetchStoreCustomerOrderRevenue = async () => {
  //   try {
  //     const response = await getStoreCustomerOrderRevenue(storeCustomerId, storeId);
  //     if (!response.data.error) {
  //       const Res = response.data;
  //       setStoreCustomerOrderRevenue(Res);
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //   }
  // };

  const fetchCustomerOldOrderLedger = (data) => {
    getCustomerOldOrderLedger(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOldOrderLedgerData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    let initialStartDate = new Date();
    setStartDateDashboard(new Date(initialStartDate));

    let initialEndDate = new Date();
    initialEndDate.setDate(initialEndDate.getDate() + 7);
    setEndDateDashboard(new Date(initialEndDate));
  }, []);

  useEffect(() => {
    // Move the fetchStoreCustomerInfo function inside the callback

    // fetchStoreCustomerAccount();
    fetchStoreCustomerInfo(); // Call the function when the screen is focused
    // fetchStoreData();
    fetchCustomerOrders(); // Call the function when the screen is focused

    fetchCartDetail();
    // fetchStoreCustomerOrderRevenue();
    if (enabledOldOrderFeature) {
      const data = {
        brandId: brandId,
        storeCustomerIdIn: [storeCustomerId],
      };
      fetchCustomerOldOrderLedger(data);
    }

    const data1 = {
    storeIdIn: [storeId],
    statusIn: [
        "BOOKED",
        "INPROCESS",
        "PROCESSED",
        "IN_WAREHOUSE",
        "DELIVERED",
        "DONE",
        "OUT_FOR_DELIVERY",
        "CANCEL",
        "DELAY"
    ],
    storeCustomerIdIn: [storeCustomerId],
    pendingRevenue: true
  };

    fetchStoreCustomerOrderRevenueAll(data1);

    //   const timeoutId = setTimeout(() => {
    //     setShowActivityIndicator(false);
    //   }, 3000);

    //   return () => clearTimeout(timeoutId);
  }, [storeCustomerId, storeId]); // Add storeCustomerId and storeId as dependencies

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);
  const receiveResponse = ({ message, status, modalFun }) => {
    setApiResStatus(status);
    setApiResMessage(message);
    setCollectPaymentResponse(modalFun);
  };

  useEffect(() => {
    if (collectPaymentResponse === false) {
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  const noOfAllOrders = customerALLOrdersData.length;
  const noOfDoneDeliveredOrder = customerALLOrdersData.filter(
    (item) => item.status === "DONE" || item.status === "DELIVERED"
  );

  const DeliveredOrders = customerALLOrdersData.filter((order) => order.status === "DELIVERED")

  const CustomerInformation = {
    firstName: customerData?.brandCustomer?.firstName
      ? customerData?.brandCustomer?.firstName
      : "",
    lastName: customerData?.brandCustomer?.lastName
      ? customerData?.brandCustomer?.lastName
      : "",
    customerId: customerData?.customerId ? customerData?.customerId : "",
    mobile: customerData?.brandCustomer?.mobile
      ? customerData?.brandCustomer?.mobile
      : "N/A",
    addressLine1: customerData?.address?.addressLine1
      ? customerData?.address?.addressLine1
      : "",
    addressLine2: customerData?.address?.addressLine2
      ? ", " + customerData?.address?.addressLine2
      : "",
    city: customerData?.address?.city ? ", " + customerData?.address?.city : "",
    state: customerData?.address?.state
      ? ", " + customerData?.address?.state
      : "",
    landmark: customerData?.address?.landmark
      ? ", " + customerData?.address?.landmark
      : "",
    pin: customerData?.address?.pin ? ", " + customerData?.address?.pin : "",

    rating: customerData?.brandCustomer?.starRating
      ? customerData?.brandCustomer?.starRating
      : "N/A",
    lastVisit: customerData?.lastVisit
      ? formatDateNew(customerData?.lastVisit)
      : "N/A",
    lastVisitDays: customerData?.lastVisit
      ? Math.round(
          (new Date().getTime() - new Date(customerData?.lastVisit).getTime()) /
            (1000 * 3600 * 24)
        )
      : "N/A",
    lastPaymentMode: customerData?.lastPaymentMode
      ? customerData?.lastPaymentMode
      : "N/A",
    business: customerData ? "N/A" : "N/A",
    walletBalance: customerData.walletBalance
      ? Number(customerData.walletBalance).toFixed(enabledAmountRoundOff)
      : 0,
    loyaltyPoint: customerData.loyaltyPoint ? customerData.loyaltyPoint : 0,
    frequency:
      storeCustomerPendingOrderOverAllRevenueData?.orderCount > 0
        ? storeCustomerPendingOrderOverAllRevenueData?.orderCount >= 1
          ? Math.round(
              (new Date().getTime() -
                new Date(customerData?.createdDate).getTime()) /
                (1000 * 3600 * 24) /
                storeCustomerPendingOrderOverAllRevenueData?.orderCount
            )
          : 0
        : 0,
    // averageRevenue:
    //   noOfDoneDeliveredOrder.length > 0
    //     ? Math.round(customerData.revenue / noOfDoneDeliveredOrder.length)
    //     : 0,
  };

  const onSelectServiceCardItem = (item) => {
    if (item.id === 1) {
      navigate("/BookNewOrder", {
        state: {
          customerData: customerData,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 2) {
      setPickupRequestModalVisible(true);
    } else if (item.id === 3) {
      setDeliveryRequestModalVisible(true);
    } else if (item.id === 4) {
      navigate("/WalletLedgerSelection", {
            state: {
              customerData: customerData,
              storeCustomerId: storeCustomerId,
            },
          })
      // customerAccountEnable === true
      //   ? Alert.alert(
      //       "Wallet Account",
      //       "To Access Wallet Account Please Contact Your Administrator."
      //     )
      //   : navigate("/WalletLedgerSelection", {
      //       state: {
      //         customerData: customerData,
      //         storeCustomerId: storeCustomerId,
      //       },
      //     });
    } else if (item.id === 5) {
      navigate("/CustomerInfoOrders", {
        state: {
          orderFilterData: {
            statusIn: [
              "BOOKED",
              "IN_WAREHOUSE",
              "PROCESSED",
              "INPROCESS",
              "OUT_FOR_DELIVERY",
              "DELIVERED",
              "DELAY",
            ],
            recordType: "orderOn",
            startDate: localeDateStartDate(new Date(startDateDashboard)),
            endDate: localeDateEndDate(new Date(endDateDashboard)),
          },
          source: "s2",
          typeOfOrder: "Running Order",
          storeCustomerId: storeCustomerId,
          mobileNumber: CustomerInformation.mobile,
          navigateThrough: 'GoBack'
        },
      });
    } else if (item.id === 6) {
      navigate("/CustomerInfoOrders", {
        state: {
          orderFilterData: {
            statusIn: ["DONE", "DELIVERED"],
            recordType: "orderOn",
            startDate: localeDateStartDate(new Date(startDateDashboard)),
            endDate: localeDateEndDate(new Date(endDateDashboard)),
          },
          source: "s2",
          typeOfOrder: "Close Order",
          storeCustomerId: storeCustomerId,
          mobileNumber: CustomerInformation.mobile,
          navigateThrough: 'GoBack'
        },
      });
    } else if (item.id === 7) {
      navigate("/CustomerInfoOrders", {
        state: {
          orderFilterData: {
            statusIn: ["CANCEL", "UNPROCESSED"],
            recordType: "orderOn",
            startDate: localeDateStartDate(new Date(startDateDashboard)),
            endDate: localeDateEndDate(new Date(endDateDashboard)),
          },
          source: "s2",
          typeOfOrder: "Cancel Order",
          storeCustomerId: storeCustomerId,
          mobileNumber: CustomerInformation.mobile,
          navigateThrough: 'GoBack'
        },
      });
    } else if (item.id === 8) {
      navigate("/CustomerInfoOrders", {
        state: {
          orderFilterData: {
            statusIn: [
              "BOOKED",
              "IN_WAREHOUSE",
              "PROCESSED",
              "INPROCESS",
              "DONE",
              "OUT_FOR_DELIVERY",
              "DELIVERED",
              "DELAY",
              "CANCEL",
              "UNPROCESSED",
            ],
            recordType: "",
            startDate: localeDateStartDate(new Date(startDateDashboard)),
            endDate: localeDateEndDate(new Date(endDateDashboard)),
          },
          source: "s2",
          typeOfOrder: "All Order",
          storeCustomerId: storeCustomerId,
          mobileNumber: CustomerInformation.mobile,
          navigateThrough: 'GoBack'
        },
      }); // all status
    } else {
      navigate("/");
    }
  };

  const navigateToCartPage = () => {
    navigate("/CartPage", {
      state: {
        storeCustomerId: storeCustomerId,
      },
    });
  };

  // Not in used

  // const handleNotificationModal = (messageType) => {
  //   setOrderNotificationVisible(true);
  //   setOrderNotificationMessageType(messageType);
  // };

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#fff",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-xl font-bold capitalize">Customer Info</p>
            </div>
          </div>
          <div
            className="flex justify-content-center align-items-center mr-4"
            onClick={() => cartData.length > 0 && navigateToCartPage()}
            style={{
              cursor: "pointer",
            }}
          >
            <i
              className="pi pi-shopping-cart"
              style={{ fontSize: "27px", color: "#000" }}
            ></i>
            {cartData.length > 0 && (
              <div
                style={{
                  position: "relative",
                  backgroundColor: "red",
                  height: 25,
                  width: 25,
                  borderRadius: 50,
                  top: -7,
                  right: 5,
                }}
              >
                <p className="text-white text-lg text-center font-bold capitalize">
                  {cartData.length}
                </p>
              </div>
            )}
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className=" card surface-0 flex-1  mx-4"
        style={{
          backgroundImage:
            "radial-gradient(circle at left top, #1752AA, #2B70D7)",
        }}
      >
        <div className="px-4">
          <div className="grid mt-1">
            <div className="col-3">
              <p className="text-white text-lg font-normal capitalize">
                Customer Name :
              </p>
              <div>
                <p className="text-white text-xl font-semibold capitalize">
                  {CustomerInformation?.firstName}{" "}
                  {CustomerInformation?.lastName}
                </p>
                {CustomerInformation.customerId && (
                  <p className="text-white text-sm font-semibold capitalize">
                    {"(" + CustomerInformation.customerId + ")"}
                  </p>
                )}
              </div>
            </div>
            <div className="col-3">
              <p className="text-white text-lg font-normal capitalize">
                Mobile No. :
              </p>
              <p className="text-white text-xl font-semibold capitalize">
                {CustomerInformation?.mobile}
              </p>
            </div>
            <div className="col-3">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="text-white text-lg font-normal capitalize">
                  Last Visit :
                </p>
                {CustomerInformation.lastVisitDays > 0 && (
                  <div
                    style={{
                      marginLeft: 4,
                      backgroundColor: "#fff",
                      borderRadius: 5,
                      paddingVertical: 2,
                      paddingHorizontal: 4,
                      alignSelf: "center",
                    }}
                  >
                    <p
                      className=" text-md font-normal capitalize px-1 text-color"
                      style={{
                        "--text-color": "#2B70D7",
                      }}
                    >
                      {CustomerInformation.lastVisitDays + " Days"}
                    </p>
                  </div>
                )}
              </div>
              <p className="text-white text-xl font-semibold capitalize">
                {CustomerInformation.lastVisit}
              </p>
            </div>
            {/* <div className="col">
              <div>
                <p className="text-white text-lg font-normal capitalize">
                  Rating :
                </p>
              </div>
              <div className="flex gap-2">
                {maxRating.map((item, key) => {
                  return (
                    <div activeOpacity={0.7} key={key}>
                      <img
                        style={{
                          width: 25,
                          height: 25,
                        }}
                        src={
                          item <= defaultRating
                            ? "Icons/star-fill.png"
                            : "Icons/star.png"
                        }
                      />
                    </div>
                  );
                })}
              </div>
            </div> */}
            <div className="col-3">
              <p className="text-white text-lg font-normal capitalize">
                Frequency Of Order:
              </p>
              <p className="text-white text-xl font-semibold capitalize">
                {CustomerInformation.frequency >= 1
                  ? CustomerInformation.frequency + " Days"
                  : Math.round(
                      storeCustomerPendingOrderOverAllRevenueData?.revenue
                    ) == 0 && CustomerInformation.frequency == 0
                  ? "No Order Placed Yet!"
                  : "Every Day"}
              </p>
            </div>

            {enabledCustomerRevenueDetailV2 && (
              <div className="col-3">
                <p className="text-white text-lg font-normal capitalize">
                  Revenue :
                </p>
                <p className="text-white text-xl font-semibold capitalize">
                  {storeLocalData?.currencySymbol}{" "}
                  {storeCustomerPendingOrderOverAllRevenueData?.revenue > 0
                    ? Number(
                        storeCustomerPendingOrderOverAllRevenueData?.revenue
                      ).toFixed(enabledAmountRoundOff)
                    : 0}
                </p>
              </div>
            )}

            <div className="col-3">
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p className="text-white text-lg font-normal capitalize">
                  Delivered Order Balance:
                </p>
                <div
                  onClick={() =>
                    navigate("/OrderDeliveredComponent", {
                      state: {
                        // customerOrdersData:DeliveredOrders,
                        storeCustomerId: storeCustomerId,
                      },
                    })
                  }
                  className="mx-2 cursor-pointer"
                >
                  <i
                    className="pi pi-eye"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      color: "#fff",
                    }}
                  ></i>
                </div>
              </div>
              <p className="text-white text-xl font-semibold capitalize">
                {storeLocalData?.currencySymbol}{" "}
                {storeCustomerDeliveredOrderBalance.balance > 0
                  ? Number(storeCustomerDeliveredOrderBalance?.balance)?.toFixed(enabledAmountRoundOff)
                  : 0}
              </p>
            </div>

            {storeCustomerUpcomingOrderRevenueData?.balance > 0 && (
              <div className="col-3">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <p className="text-white text-lg font-normal capitalize">
                    Pending Order Balance :
                  </p>

                  <div
                    style={{
                      marginLeft: 4,
                      backgroundColor: "#fff",
                      borderRadius: 5,
                      paddingVertical: 2,
                      paddingHorizontal: 4,
                      alignSelf: "center",
                    }}
                  >
                    <p
                      className=" text-md font-normal capitalize px-1 text-color"
                      style={{
                        "--text-color": "#2B70D7",
                      }}
                    >
                      {storeCustomerUpcomingOrderRevenueData?.count}
                    </p>
                  </div>
                </div>
                <p className="text-white text-xl font-semibold capitalize">
                  {storeLocalData?.currencySymbol} {Number(storeCustomerUpcomingOrderRevenueData?.balance)?.toFixed(enabledAmountRoundOff)}
                </p>
              </div>
            )}
            {enabledCustomerRevenueDetailV2 &&
              storeCustomerPendingOrderOverAllRevenueData?.revenue > 0 && (
                <div className="col-3">
                  <p className="text-white text-lg font-normal capitalize">
                    Average Revenue:
                  </p>
                  <p className="text-white text-xl font-semibold capitalize">
                  {storeLocalData?.currencySymbol}
                    {" " +
                      Number(
                        storeCustomerPendingOrderOverAllRevenueData?.revenue /
                          storeCustomerPendingOrderOverAllRevenueData?.count
                  )?.toFixed(enabledAmountRoundOff) }
                  </p>
                </div>
              )}

            {enabledOldOrderFeature &&
              customerOldOrderLedgerData.totalSale > 0 && (
                <div className="col-3">
                  <p className="text-white text-lg font-normal capitalize">
                    Old Order Revenue :
                  </p>
                  <p className="text-white text-xl font-semibold capitalize">
                  {storeLocalData?.currencySymbol} {Number(customerOldOrderLedgerData.totalSale)?.toFixed(enabledAmountRoundOff)}
                  </p>
                </div>
              )}
            {enabledOldOrderFeature &&
              customerOldOrderLedgerData.totalBalance > 0 && (
                <div className="col-3">
                  <p className="text-white text-lg font-normal capitalize">
                    Old Order Balance :
                  </p>
                  <p className="text-white text-xl font-semibold capitalize">
                  {storeLocalData?.currencySymbol} {Number(customerOldOrderLedgerData.totalBalance)?.toFixed(enabledAmountRoundOff)}
                  </p>
                </div>
              )}
            <div className="col-3">
              <p className="text-white text-lg font-normal capitalize">
                Wallet Balance :
              </p>
              <p className="text-white text-xl font-semibold capitalize">
                {storeLocalData?.currencySymbol} {Number(CustomerInformation?.walletBalance)?.toFixed(enabledAmountRoundOff)}
              </p>
            </div>
            {enabledLoyaltyPointBrand && enabledLoyaltyPointStore && (
              <div className="col-3">
                <div style={{ display: "flex", flexDirection: "row" }}>
                  <p className="text-white text-lg font-normal capitalize">
                    Loyalty Points:
                  </p>
                  <div
                    onClick={() =>
                      navigate("/Customer-Loyalty-Point-Log", {
                        state: {
                          storeCustomerId: storeCustomerId,
                          loyaltyPoint: CustomerInformation.loyaltyPoint,
                        },
                      })
                    }
                    className="mx-2 cursor-pointer"
                  >
                    <i
                      className="pi pi-eye"
                      style={{
                        fontSize: "20px",
                        cursor: "pointer",
                        color: "#fff",
                      }}
                    ></i>
                  </div>
                </div>
                <p className="text-white text-xl font-semibold capitalize">
                  {CustomerInformation.loyaltyPoint
                    ? CustomerInformation.loyaltyPoint
                    : 0}
                </p>
              </div>
            )}

            <div className="col-12">
              <p className="text-white text-lg font-normal capitalize">
                Address :
              </p>
              <p className="text-white text-xl font-semibold capitalize">
                {CustomerInformation.addressLine1}
                {CustomerInformation.addressLine2}
                {CustomerInformation.landmark} {CustomerInformation.city}
                {CustomerInformation.state} {CustomerInformation.pin}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex-1  mx-4">
        <div className="grid">
          {CardData.map((item) => (
            <div
              className="col"
              onClick={() => onSelectServiceCardItem(item)}
              style={{ cursor: "pointer" }}
            >
              <div
                className="flex justify-content-center"
                style={{
                  height: height < 600 ? 60 : 75,
                }}
              >
                <img
                  style={{
                    height: item.height,
                    width: item.width,
                    // alignSelf: 'center',
                  }}
                  src={item.gif}
                />
              </div>
              <p className="text-center text-lg  font-normal ">{item.name}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex-1  surface-0" style={{ "--surface-0": "#EAEFF5" }}>
        <div className="flex justify-content-between mx-4">
          <div className="py-1">
            <p className=" text-2xl  font-bold ">Order Info</p>
          </div>
          <div className="flex justify-content-center gap-3">
          {customerOrdersData.length > 0 && (
            <div
              className="align-self-center py-1 px-2"
              onClick={() =>
                navigate("/GetAllOrder", {
                  state: {
                    customerALLOrdersData,
                    storeCustomerId,
                    navigateThrough: "GoBack",
                  },
                })
              }
              style={{
                backgroundColor: "#2B70D7",
                borderRadius: 5,
                cursor: "pointer",
              }}
            >
              <p className=" text-md text-center text-white font-semibold ">
                View All
              </p>
            </div>
          )}
          {(B2BModelBrand && B2BModelStore) && 
          <div
            className="align-self-center py-1 px-2"
            onClick={() =>
              navigate("/B2BGetAllOrder", {
                state: {                  
                  storeCustomerId,
                  navigateThrough: "GoBack",
                },
              })
            }
            style={{
              backgroundColor: "green",
              borderRadius: 5,
              cursor: "pointer",
            }}
          >
            <p className=" text-md text-center text-white font-semibold ">
              Convert B2B to B2C Order
            </p>
          </div>}
          </div>
        </div>
      </div>
      <div className="flex-1 mx-4 mt-3 mb-3 ">
        <Accordion>
          {customerOrdersData.map((order, index) => {
            const orderStatusColor =
              OrderStatusColors[order.status] || OrderStatusColors.DEFAULT;
            const displayDate =
              order.status === "DELIVERED" || order.status === "DONE"
                ? order.deliveredOn
                : order.deliveryOn;
            const displayBalanceText =
              order.status === "DELIVERED" ? "| Balance" : "";
            const displayBalanceAmount =
              order.status === "DELIVERED" ? "| " + order.balanceAmount : "";
            const displayDeliveryDateText =
              order.status === "DELIVERED" || order.status === "DONE"
                ? "Delivered On"
                : "Delivery Date";
            const formattedCreatedDate = formatDateNew(order.createdDate);
            const formattedDeliveryDate = formatDateNew(displayDate);
            return (
              <AccordionTab
                key={index}
                style={{
                  "--backgroundColor-AccordionTab":
                    OrderStatusColors[order.status],
                }}
                header={`${
                  order.invoiceNo || "N/A"
                } | ${formattedCreatedDate}  ${order.status.replace(
                  /_/g,
                  " "
                )}`}
              >
                <div
                  className="cursor-pointer"
                  onClick={() =>
                    userRole === "BY_ADMIN" || userRole === "BY_SUB_ADMIN_USER"
                      ? navigate("/OrdersGarmentInfo", {
                          state: {
                            storeIdValue: order.storeId,
                            bookingOrderId: order.id,
                            storeCustomerId: order.storeCustomerId,
                          },
                        })
                      : navigate("/OrdersGarmentInfo", {
                          state: {
                            bookingOrderId: order.id,
                            storeCustomerId: order.storeCustomerId,
                          },
                        })
                  }
                >
                  <div className="flex-row">
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        Order No:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {order.orderNo || "N/A"}
                      </p>
                    </div>
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        Invoice No:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {order.invoiceNo || 0}
                      </p>
                    </div>
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        {displayDeliveryDateText}:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {formattedDeliveryDate}
                      </p>
                    </div>
                  </div>

                  <div className="flex-row">
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        Invoice {displayBalanceText} Amount:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {order.grandTotal} {displayBalanceAmount}
                      </p>
                    </div>
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        Order Source:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {order.orderSource
                          ? order.orderSource.replace(/_/g, " ")
                          : ""}
                      </p>
                    </div>
                    <div className="col-4">
                      <p className="text-base font-semiBold capitalize">
                        Remarks:
                      </p>
                      <p className="text-lg font-bold capitalize">
                        {order.remarks}
                      </p>
                    </div>
                  </div>
                  <div className="flex-row">
                    {order.deliveryRemarks && (
                      <div className="flex-row">
                        <div className="col-4">
                          <p className="text-base font-semiBold capitalize">
                            Delivery Remark:
                          </p>
                          <p className="text-lg font-bold capitalize">
                            {order.deliveryRemarks}
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </AccordionTab>
            );
          })}
        </Accordion>
        {loading ? (
          <div className="text-center">
            <ProgressSpinner
              style={{ width: "70px", height: "70px" }}
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration="2s"
            />
          </div>
        ) : customerOrdersData.length <= 0 ? (
          <div>
            <p className="text-2xl text-center font-bold capitalize">
              No Order Present
            </p>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="relative mt-8">
        <div
          className="flex flex-1 flex-row gap-5  py-2 fixed w-full z-2 bottom-0"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
            <Button
              label="Edit Customer"
              onClick={() =>
                navigate("/EditCustomer", {
                  state: {
                    customerData: customerData,
                    storeCustomerId: storeCustomerId,
                  },
                })
              }
              className="p-2 w-full text-xl border-1 "
              style={{
                color: "#2B70D7",
                backgroundColor: "#fff",
                borderRadius: 5,
              }}
            ></Button>
            <div
              className="p-2 w-full text-center text-xl border-1 cursor-pointer"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-book  text-center"
                style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
              ></i>
            </div>
            <div
              className="p-2 w-full text-center text-xl border-1 cursor-pointer"
              // onClick={() => handleNotificationModal("WhatsAppMessage")}
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-whatsapp text-center"
                style={{
                  fontSize: "30px",
                  cursor: "pointer",
                  color: "#fff",
                }}
              ></i>
            </div>
          </div>
        </div>
      </div>

      {pickupRequestModalVisible && (
        <PickupRequest
          setPickupRequestModalVisible={setPickupRequestModalVisible}
          pickupRequestModalVisible={pickupRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          editMode={false}
          storeCustomerId={storeCustomerId}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={{
            id: null,
            storeCustomerId: null,
            storeUserId: null,
            pickupDeliveryTimeSlot: null,
            pickupOn: null,
            riderName: null,
            orderId: null,
            pickupDeliveryStatus: null,
          }}
        />
      )}
      {deliveryRequestModalVisible && (
        <DeliveryRequest
          setDeliveryRequestModalVisible={setDeliveryRequestModalVisible}
          deliveryRequestModalVisible={deliveryRequestModalVisible}
          status={"success"}
          text={"Your order is placed successfully."}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          sendResponse={receiveResponse}
          pickupDeliveryRequestData={{
            id: null,
            storeCustomerId: null,
            storeUserId: null,
            pickupDeliveryTimeSlot: null,
            pickupOn: null,
            riderName: null,
            orderId: null,
            pickupDeliveryStatus: null,
            invoiceNo: null,
            createdDate: null,
          }}
        />
      )}
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={apiResStatus === true ? "success" : false}
        text={apiResMessage}
      />
      {/*selectedItem === null ? undefined : (
        <OrderNotification
          setOrderNotificationVisible={setOrderNotificationVisible}
          orderNotificationVisible={orderNotificationVisible}
          mobileNumber={CustomerInformation.mobile}
          orderNotificationMessageType={orderNotificationMessageType}
          storeCustomerId={storeCustomerId}
          storeId={storeId}
          bookingOrderId={selectedItem}
          userRole={userRole}
        />
      )*/}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <audio
              ref={audioRef}
              preload="auto"
              // src="https://qdc-static-assets.s3.ap-south-1.amazonaws.com/pickup-notifications/ding.mp3"
              src={PickupNotification}
            />
      <div className="flex justify-content-center">
                            <Toast ref={toast} />                
                        </div>
    </div>
  );
};

export default CustomerInfo;
